<template>
  <div class="sidebar" ref="sidebar">
    <ul class="sidebar-links">
      <li class="sidebar-nav">
        <a href="https://github.com/blryli/vue-form-layer/blob/master/VERSIONS.md" target="_blank" rel="noopener noreferrer" class="sidebar-link">
          更新日志
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon outbound">
            <path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path>
            <polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon>
          </svg>
        </a>
      </li>
      <li class="sidebar-nav">
        <a href="https://github.com/blryli/vue-form-layer" target="_blank" rel="noopener noreferrer" class="sidebar-link">
          GitHub
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" x="0px" y="0px" viewBox="0 0 100 100" width="15" height="15" class="icon outbound">
            <path fill="currentColor" d="M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"></path>
            <polygon fill="currentColor" points="45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"></polygon>
          </svg>
        </a>
      </li>
      <li v-for="(link, idx) in links" :key="idx">
        <router-link v-if="!link.children" class="sidebar-link" :to="link.path" @click.native="$root.sidebarShow = false">{{link.name}}</router-link>
        <div v-else class="sidebar-group">
          <h2 class="sidebar-heading">{{link.name}}</h2>
          <ul class="sidebar-group-items">
            <li v-for="(lin, i) in link.children" :key="i">
              <router-link class="sidebar-link" :to="lin.path" @click.native="$root.sidebarShow = false">{{lin.name}}</router-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { links } from "./sidebar-link.js";

export default {
  name: "sidebar",
  data() {
    return {
      links: links
    };
  },
  watch: {
    "$root.sidebarShow"(val) {
      const sidebar = this.$refs.sidebar;
      val ? sidebar.classList.add("open") : sidebar.classList.remove("open");
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  font-size: 15px;
  background-color: #fff;
  width: 14rem;
  position: fixed;
  z-index: 10;
  margin: 0;
  top: 3.6rem;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  border-right: 1px solid #eaecef;
  overflow-y: auto;
  transform: translateX(-100%);
  transition: transform 0.2s ease;
  &.open {
    transform: translateX(0);
  }
  ul {
    list-style-type: none;
    line-height: 1.5em;
  }
}

.sidebar-links {
  padding: 1.5rem 0;
  margin: 0;
}

.sidebar-link {
  display: inline-block;
  border-left: 0.25rem solid transparent;
  padding: 0.35rem 1rem 0.35rem 1.25rem;
  line-height: 1.4;
  width: 100%;
  box-sizing: border-box;
}
.sidebar-heading {
  color: #1f2d3d;
  transition: color 0.15s ease;
  font-size: 1.1em;
  font-weight: 700;
  padding: 0 1.5rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.sidebar-group {
  .sidebar-link {
    padding-left: 2rem;
  }
  &:not(.first) {
    margin-top: 1em;
  }
}
.sidebar-nav {
  display: block;
  .sidebar-link {
    font-weight: bold;
  }
  &:nth-child(2){
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eaecef;
  }
}
@media (min-width: 768px) {
  .sidebar {
    width: 14rem;
    transform: translateX(0);
  }
  .sidebar-nav {
    display: none;
  }
}
@media (min-width: 992px) {
  .sidebar {
    width: 16rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/layou/sidebar.vue